// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2Sp-4","fileBtn":"File_fileBtn__2FXYv","closeBtn":"File_closeBtn__1qyPe","fileSelected":"File_fileSelected__2HIHN","disabled":"File_disabled__2MetC"};